<template>
    <img src="@/assets/icons/homescapes.jpg" v-if="project === 'HS'" />
    <img src="@/assets/icons/gardenscapes.jpg" v-else-if="project === 'GS'" />
    <img src="@/assets/icons/fishdom.jpg" v-else-if="project === 'FD'" />
    <img src="@/assets/icons/wildscapes.jpg" v-else-if="project === 'WS'" />
    <img src="@/assets/icons/township.jpg" v-else-if="project === 'TS'" />
    <img src="@/assets/icons/memories.jpg" v-else-if="project === 'MMR'" />
    <img src="@/assets/icons/manormatters.jpg" v-else-if="project === 'MM'" />
    <img src="@/assets/icons/greenvile.jpg" v-else-if="project === 'GV'" />
    <img src="@/assets/icons/skycharms.jpg" v-else-if="project === 'SC'" />
    <img src="@/assets/icons/farmscapes.png" v-else-if="project === 'FS'" />
    <img src="@/assets/icons/fishdom_solitaire.png" v-else-if="project === 'FDS'" />
    <img src="@/assets/icons/puzzle_breaker.png" v-else-if="project === 'PB'" />
    <img src="@/assets/icons/fishdom_blast.png" v-else-if="project === 'FDB'" />
</template>

<script>
export default {
  name: 'playable-avatar',
  props: {
    project: String
  }
}
</script>

<style scoped>

</style>
